import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

const lgoBadgeVariants = cva(
  "inline-flex items-center rounded-full border font-medium tracking-wide transition-colors",
  {
    variants: {
      variant: {
        gold: "bg-primary/10 text-foreground border-primary/30",
        neutral: "bg-muted text-muted-foreground border-transparent",
        success: "bg-success/10 text-success border-success/30",
        danger: "bg-destructive/10 text-destructive border-destructive/30",
        info: "bg-secondary text-secondary-foreground border-border",
        outline: "bg-transparent text-foreground border-border",
        attention: "bg-primary text-primary-foreground border-transparent",
      },
      size: {
        xs: "px-1.5 py-0 text-[10px] leading-4",
        sm: "px-2 py-0.5 text-[11px]",
        md: "px-2.5 py-1 text-xs",
      },
    },
    defaultVariants: {
      variant: "neutral",
      size: "sm",
    },
  },
);

export interface LGoBadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof lgoBadgeVariants> {}

export const LGoBadge = React.forwardRef<HTMLSpanElement, LGoBadgeProps>(
  ({ className, variant, size, ...props }, ref) => (
    <span ref={ref} className={cn(lgoBadgeVariants({ variant, size }), className)} {...props} />
  ),
);
LGoBadge.displayName = "LGoBadge";

export { lgoBadgeVariants };
